import React from 'react';

import { useWindow } from 'app/hooks/useWindow.hook';
import { SIZE } from 'app/utils/sizes';
import { usePostHog } from 'posthog-js/react';

import 'app/components/Banxware/Banxware.scss';

export default function Banxware() {
  const { width } = useWindow();
  const posthog = usePostHog();

  const mobile = width < SIZE.LG;

  return (
    <a
      href="https://lp.banxware.com/flex/bigbuy?utm_source=bigbuy&utm_medium=bannerfooter&utm_campaign=blackfriday_banxware"
      target="_blank"
      rel="noopener noreferrer"
      className="bb-banxware"
      onClick={() => {
        posthog.capture('banner_banxware_clicked');
      }}
    >
      {mobile ? (
        <img
          src="https://cms.bigbuy.eu/uploads/Banxware_Banner_mobile_77752c3421.png"
          alt="Banxware"
          className="bb-banxware__image__mobile"
        />
      ) : (
        <img
          src="https://cms.bigbuy.eu/uploads/Banxware_Banner_desktop_36c9671071.png"
          alt="Banxware"
          className="bb-banxware__image__desktop"
        />
      )}
    </a>
  );
}
